<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <LabelDetail :form-data="data" slot-scope="{data}" :label-type-prop="$route.query.type"></LabelDetail>
  </l-cache>
</template>
<script>
import LabelDetail from './labelDetail'
export default {
  name: 'labelDetailBox',
  components: {LabelDetail},
  methods: {
    async getItem (key) {
      let pagination = {pages: 1, rowsPerPage: 10}
      let type = this.$route.query.type
      let id = this.$route.query.id
      if (type === 'sys') {
        let url = '/messageApi/admin/getMsgLabelSys'
        let {items, amount} = await this.$store.dispatch('message/getList', {pagination, search: {key: 'id', value: id}, url: url})
        if (items.length !== 0) {
          return items[0]
        }
        else {
          this.$L.alert('error', {message: '查询失败，未查到该标签'})
        }
      }
      else {
        let url = '/messageApi/admin/getMsgLabelBiz'
        let {items, amount} = await this.$store.dispatch('message/getList', {pagination, search: {key: 'id', value: id}, url: url})
        if (items.length !== 0) {
          return items[0]
        }
        else {
          this.$L.alert('error', {message: '查询失败，未查到该标签'})
        }
      }
    }
  }
}
</script>
